<template>
  <transition name="rw">
    <div
      v-if="show"
      class="absolute w-full max-w-md left-0 right-0 mt-6 mx-auto pl-4 pr-2 py-3 bg-warning z-reloadWarning"
    >
      <div class="flex items-center">
        <lm-icon icon="warning" class="mr-2 flex-shrink-0 text-gray-700" />
        <span class="max-w-md mr-4 text-s leading-tight text-gray-900">
          The structure of the Landscape has been modified.
        </span>
        <div class="ml-auto flex items-center">
          <lm-icon-button
            class="mr-1"
            svg
            bg-black
            icon="close"
            @click="close"
          />
        </div>
      </div>
      <lm-button class="mt-4" mini @click="reload">Reload App</lm-button>
    </div>
  </transition>
</template>

<script>
import LmButton from '@/components/ui/LmButton'
import LmIcon from '@/components/ui/LmIcon'
import LmIconButton from '@/components/ui/LmIconButton'
import EventHub from '@/lib/eventHub'
import {Events} from '@/lib/definitions'

export default {
  name: 'ReloadWarning',
  components: {LmIcon, LmButton, LmIconButton},
  data() {
    return {
      show: false
    }
  },
  mounted() {
    EventHub.on(Events.SHOW_RELOAD_WARNING, () => {
      this.show = true
    })
  },
  methods: {
    close() {
      this.$store.dispatch('setAccessDate')
      this.show = false
    },
    reload() {
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.rw-enter-active,
.rw-leave-active {
  transition: opacity 0.5s ease,
    transform 0.5s cubic-bezier(0.04, 0.13, 0.55, 0.9);
}
.rw-enter,
.rw-leave-to {
  opacity: 0;
  transform: translateY(-40%);
}
</style>
